unit f_note;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  f_noteinserisci, f_notemodifica, DateUtils, f_selezione, w_edit, un_servermodule, w_label,
  un_telemetria, UnArrayDef, DB, un_generator, f_notecategorie, un_user;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo le ultime 300 note' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare le note';
  msgNessunRecord = 'Nessun record da visualizzare';
  msgCaricamentoInCorso = 'Caricamento note in corso...';

type
  { TFrmNote }

  TFrmNote = class(TWidget)
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
  private
    procedure ShowNote; async;
    procedure qrynoteOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
  published
    procedure tab1_rowclick; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure dscategoria_change;
    procedure flchiusa_click; async;
    procedure dscategoria_click; async;
    procedure lblHeader_click; async;
    procedure nuovanota_click; async;
    procedure btnCategorie_click; async;
    dscategoria: TJSHTMLSelectElement;
    filtro: TWEdit;
    pnltab1: TJSHTMLElement;
    qrynote: TQuery;
    QryResponsabile: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
    pnlTabella:TJSHTMLElement;
    flchiusa:TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmNote }

procedure TFrmNote.AfterRender;
begin

  qrynote.OnFilterRecord := @qrynoteOnFilterRecord;

  filtro.placeholder := 'Ricerca note...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';

  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  flchiusa.checked:=true;

  ShowNote;

end;

procedure TFrmNote.AfterDomAppend;
begin

//  ShowNote;

end;

procedure TFrmNote.ShowNote; async;
begin

   ImpostaVisibilita(visCaricamentoInCorso);

 // cerco l'utente RESP per mostrare più dati
  QryResponsabile.Close;
  QryResponsabile.SQL.Text := 'select * from utentigruppi  '
  + ' where idsocieta = ''DON001'' '
  + ' and idutente = ''' + user.QryUtenti.FieldByName('idutente').AsString + ''' '
  + ' and idgruppo = ''RESP'' ';
  AWait(QryResponsabile.Open);

  QryNote.Close;
  QryNote.SQL.Text:= ' select dtscadenza as scad, dscategoria as dscategoria, dstitolo as titolo, dsnota as nota, '
                     + ' dsemail, flstato, idnota as idnota, idsocieta from no_note  '
                     + ' where 1=1 ';

  if dscategoria.value <> 'TUTTE LE CATEGORIE' then
    begin
      QryNote.SQL.Text := QryNote.SQL.Text + ' and dscategoria = ' + '''' + dscategoria.value + ''''
    end;

  if flchiusa.checked then
    begin
      QryNote.SQL.Text := QryNote.SQL.Text + ' and flstato <> ''CHIUSA'' '
    end;

  if QryResponsabile.IsEmpty then
     begin
       QryNote.SQL.Text := QryNote.SQL.Text + ' and idutente = ' + '''' + user.QryUtenti.FieldByName('idutente').AsString + ''''
    end;

  QryNote.SQL.Text := QryNote.SQL.Text + ' Order by dtdata ';
  AWait(QryNote.Open);

  QryNote.FieldByName('idnota').Visible:= false;
  QryNote.FieldByName('idsocieta').Visible:= false;
  QryNote.FieldByName('dscategoria').Visible:= false;
  QryNote.FieldByName('flstato').Visible:= false;

  RefreshFiltro;

end;

procedure TFrmNote.qrynoteOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;

procedure TFrmNote.SetLabel(lbl:TWLabel;value:String);
begin

  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;

end;

procedure TFrmNote.tab1_rowclick;
var
  instance: TFrmNoteModifica;
begin

  instance := TFrmNoteModifica.Create();
  instance.idnota := qrynote.FieldByName('idnota').AsInteger;
  Await(instance.show);
  ShowNote;

end;

procedure TFrmNote.nuovanota_click;
var
  instance: TFrmNoteInserisci;
begin

  instance := TFrmNoteInserisci.Create();
  Await(instance.show);
  ShowNote;

end;

procedure TFrmNote.btnCategorie_click;
var
  instance: TFrmNoteCategorie;
begin

  instance := TFrmNoteCategorie.Create();
  instance.show;

end;

procedure TFrmNote.ImpostaVisibilita(visibilita: TVisibilita);
begin

  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];

end;

procedure TFrmNote.RefreshFiltro;
begin

  qrynote.Filtered:= filtro.value.Trim <> '';
  qrynote.First;
  tab1.RenderDataSet(qrynote);

  if qrynote.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if qrynote.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);

end;

procedure TFrmNote.filtro_change;
begin

  RefreshFiltro;

end;

procedure TFrmNote.filtro_input;
begin

  RefreshFiltro;

end;

procedure TFrmNote.dscategoria_change;
begin

  ShowNote;

end;

procedure TFrmNote.flchiusa_click;
begin

  ShowNote;

end;

procedure TFrmNote.dscategoria_click;
begin

  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;

      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= 'select dscategoria as categoria '
      + ' from no_categorie ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      dscategoria.value := QrySeleziona.FieldByName('categoria').AsString;
      Await(ShowNote);
    end;

  end;

end;

procedure TFrmNote.lblHeader_click;
begin

  ShowNote;

end;

initialization
  RegisterWeb(TFrmNote);

end.

